import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { Logo } from 'components/logos/Logo'
import { LogoColor } from 'types/types'

export const PoweredByBvnk = () => {
  const { t } = useTranslation()

  return (
    <Box flex width="full" align="center" justify="end" gap={8} className="text-foreground-faint">
      <div className="text-body-regular-small">{t('customerPendingAgreements.poweredBy')}</div>
      <Logo logoColor={LogoColor.INHERIT} isSmall />
    </Box>
  )
}
